import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VApp,
    { attrs: { "data-base-dialog": "" } },
    [
      _c(
        VDialog,
        {
          staticClass: "base-dialog",
          attrs: {
            attach: _vm.attachSelector,
            persistent: _vm.persistent,
            "max-width": _vm.maxWidth,
            "no-click-animation": _vm.noClickAnimation,
            "hide-overlay": !!_vm.attachSelector,
          },
          model: {
            value: _vm.isActive,
            callback: function ($$v) {
              _vm.isActive = $$v
            },
            expression: "isActive",
          },
        },
        [
          _c(
            VCard,
            [
              _c(VCardTitle, { staticClass: "text-h6 text--text" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t?.(_vm.title, _vm.options)) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c(
                VCardText,
                { staticClass: "text-body-1 text-secondary--text" },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t?.(_vm.text, _vm.options)) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                VCardActions,
                [
                  _c(VSpacer),
                  _vm._v(" "),
                  _vm.closeText
                    ? _c(
                        VBtn,
                        {
                          attrs: {
                            color: _vm.confirmText ? "text" : "primary",
                            text: "",
                          },
                          on: { click: _vm.handleClose },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t?.(_vm.closeText, _vm.options)) +
                              "\n        "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.confirmText
                    ? _c(
                        VBtn,
                        {
                          attrs: {
                            text: "",
                            color: _vm.isDanger ? "secondary" : "primary",
                          },
                          on: { click: _vm.handleConfirm },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t?.(_vm.confirmText, _vm.options)) +
                              "\n        "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.attachSelector
        ? _c(VOverlay, { attrs: { value: _vm.isActive, "z-index": "110" } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }